import React from 'react';

import Link from '../Link';
import './style.scss';

const Button = props => {
  const { src, value, option, disableArrowShift, onClick, effect } = props;

  const handleClick = e => {
    e.preventDefault();
    onClick && onClick();
    effect && effect();
  };

  if (onClick) {
    return (
      <button
        className={`rm btn-cb ${option ? option : ''}`}
        onClick={handleClick}
      >
        {value}
      </button>
    );
  }


    return (
      <Link
        to={src}
        className="link-region"
        style={{ textDecoration: 'none' }}
        value={
          <button
            className={`rm btn-cb d-inline-flex ${option ? option : ''} ${
              disableArrowShift ? 'disable-arrow-shift' : ''
            }`}
            onClick={() => effect && effect()}
          >
            <div className="inside align-self-center">{value}</div>
            <div className="arrow align-self-center" />
          </button>
        }
      />
    );
};

export default Button;
